import { TitleHeader } from "../../styles"
import { Description } from "../Input/styles"
import app_home_screen from '../../../../../assets/images/app_home_screen.png';
import { MenuDropdown } from "..";
import { useTranslation } from "react-i18next";
import { ActionButton } from "../../../../../components/ActionButton";
import { useMenu } from "../../hooks/useMenu";

const MenuCustomization = ({ planMeta }) => {
  const { 
    customMenu, 
    handleChangeItem, 
    menuOptions, 
    updateMenu, 
    isUpdating,
  } = useMenu({ planMeta });
  const { t } = useTranslation("common");

  return (
    <div style={{ marginLeft: 25, marginRight: 26, marginTop: 22 }}>
      <TitleHeader>{t("menu_customization")}</TitleHeader>
      <Description>{t("menu_customization_description")}</Description>
      <Description style={{ marginTop: -25 }} >{t("menu_customization_position_info")}</Description>

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <img 
          src={app_home_screen} 
          alt="Demonstração da tela inicial do App Namu" 
          style={{ width: 210, marginLeft: 10, marginBottom: 80 }} 
        />

        <div style={{ marginLeft: 20 }}>
          {customMenu.map((item, index) => (
            <MenuDropdown
              key={index} 
              index={index + 1} 
              item={item} 
              onChange={handleChangeItem} 
              options={menuOptions}
              menu={customMenu}
            />)
          )}
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: 64 }}>
        <ActionButton
          onClick={updateMenu}
          showIcon={false}
          style={{ width: 167, height: 42 }}
          disabled={isUpdating}
          isLoading={isUpdating}
        >
          <p>{t('save-plans')}</p>
        </ActionButton>
      </div>
    </div>
  );
};

export default MenuCustomization;